import { SVGProps, useId } from "react";

export default function InvitationMailIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.332 13.6667H4.66536C2.66536 13.6667 1.33203 12.6667 1.33203 10.3333V5.66666C1.33203 3.33333 2.66536 2.33333 4.66536 2.33333H11.332C13.332 2.33333 14.6654 3.33333 14.6654 5.66666V10.3333C14.6654 12.6667 13.332 13.6667 11.332 13.6667Z"
        stroke={`url(#invitation_mail_outline_${id})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3346 6L9.24797 7.66667C8.5613 8.21333 7.43463 8.21333 6.74797 7.66667L4.66797 6"
        stroke={`url(#invitation_mail_flap_${id})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={`invitation_mail_outline_${id}`}
          x1="7.9987"
          y1="2.33333"
          x2="7.9987"
          y2="13.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`invitation_mail_flap_${id}`}
          x1="8.0013"
          y1="6"
          x2="8.0013"
          y2="8.07667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
